import DisclosureService from '@/services/feature/disclosure.service';
// import moment from 'moment';

export const disclosure = {
  namespaced: true,
  state: {},
  getters: {},
  actions: {
    getPreview({ commit }, disclosure) {
      return DisclosureService.getPreview(disclosure).then(
        (resp) => {
          commit('dummy', 'getPreview - success');
          return Promise.resolve(resp);
        },
        (error) => {
          commit('dummy', 'getPreview - error');
          return Promise.reject(error.response);
        }
      );
    },

    getPreviewUrl({ commit }, disclosure) {
      return DisclosureService.getPreviewUrl(disclosure).then((resp) => {
        commit('dummy', 'getPreviewUrl - success');
        return Promise.resolve(resp);
      });
    },

    generate({ commit }, disclosure) {
      return DisclosureService.generate(disclosure).then(
        (resp) => {
          commit('dummy', 'generate - success');
          return Promise.resolve(resp);
        },
        (error) => {
          commit('dummy', 'generate - error');
          return Promise.reject(error.response);
        }
      );
    },

    sendESignatureViaDocuSign({ commit }, eDisclosure) {
      return DisclosureService.sendESignatureViaDocuSign(eDisclosure).then(
        (resp) => {
          commit('dummy', 'sendESignatureViaDocuSign - success');
          return Promise.resolve(resp);
        },
        (error) => {
          commit('dummy', 'sendESignatureViaDocuSign - error');
          return Promise.reject(error.response);
        }
      );
    },

    synchronizeDisclosureStatus({ commit }, { fileDataId, docPackageId }) {
      return DisclosureService.synchronizeDisclosureStatus(fileDataId, docPackageId).then(
        (resp) => {
          commit('dummy', 'synchronizeDisclosureStatus - success');
          return Promise.resolve(resp);
        },
        (error) => {
          commit('dummy', 'synchronizeDisclosureStatus - error');
          return Promise.reject(error.response);
        }
      );
    },

    getBusinessDay({ commit }, { afterDays, applicationDate }) {
      return DisclosureService.getBusinessDay(afterDays, applicationDate).then(
        (resp) => {
          commit('dummy', 'getBusinessDay - success');
          return Promise.resolve(resp);
        },
        (error) => {
          commit('dummy', 'getBusinessDay - error');
          return Promise.reject(error.response);
        }
      );
    },
  },
  mutations: {
    dummy(state, obj) {
      console.log(obj);
    },
  },
};
